export enum ESkuCharacteristicType {
  TEXT = 'TEXT',
  SINGLE_SELECT = 'SINGLE_SELECT',
  MULTI_SELECT = 'MULTI_SELECT',
  NUMBER = 'NUMBER',
}
